import React from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';

import { GlobalToken } from 'antd';

interface InnerCircleLabelProps {
  percentage: number;
  isHistoricalData: boolean;
  style: React.CSSProperties;
  calculatedPercentages?: { min: number; max: number };
  token: GlobalToken;
}

const InnerCircleLabel = ({ percentage, isHistoricalData, calculatedPercentages, ...rest }: InnerCircleLabelProps) => {
  const { t } = useTranslation();
  return (
    <Container {...rest}>
      <div>
        {isEmpty(calculatedPercentages) ? (
          <>
            <span className="percentage-value">{percentage == null ? 'N/A' : `${numeral(percentage).format(0)}`}</span>
            <span className="percentage-sign">{percentage != null && `%`}</span>
          </>
        ) : (
          <>
            <span className="calculated-percentage">{numeral(calculatedPercentages?.min).format(0)}</span>
            <span className="calculated-percentage">% - </span>
            <span className="calculated-percentage">{numeral(calculatedPercentages?.max).format(0)}</span>
            <span className="calculated-percentage">%</span>
          </>
        )}
      </div>
      <div className="percentage-subtitle">
        {!isEmpty(calculatedPercentages) ? t('AVG') : isHistoricalData ? t('YEAR') : t('YTD')}
      </div>
    </Container>
  );
};

const Container = styled.div<{ token: GlobalToken }>`
  text-align: center;

  .calculated-percentage {
    font-size: ${({ token }) => token.fontSizeHeading2}px;
  }

  .percentage-value {
    font-size: ${({ token }) => token.fontSizeHeading1}px;
    font-weight: ${({ token }) => token.fontWeightStrong};
    position: relative;
  }
  .percentage-sign {
    font-size: ${({ token }) => token.fontSizeHeading2}px;
    font-weight: ${({ token }) => token.fontWeightStrong};
    position: relative;
  }

  .percentage-subtitle {
    font-size: ${({ token }) => token.fontSizeSM}px;
  }
`;

export default InnerCircleLabel;
